export { default, default as FunctionalCarousel } from './FunctionalCarousel'
export { default as functionalCarouselTheme } from './themes/FunctionalCarousel.theme'
export * as FunctionalCarouselStyles from './styles/FunctionalCarousel.style'

export type { FunctionalCarouselProps, Pager } from './FunctionalCarousel.types'
export type { AppearanceKeys, FunctionalCarouselTheme } from './themes/FunctionalCarousel.theme.types'
export type { StyledFunctionalCarouselProps } from './styles/FunctionalCarousel.style.types'
